var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.accountState.selectedPatient)?_c('PurePatientTile',{attrs:{"patient":_vm.accountState.selectedPatient,"has-emergency-access":_vm.accountState.hasEmergencyAccess},on:{"logOutPatient":_vm.logOutPatient,"deactivateEmergencyAccess":_vm.deactivateEmergencyAccess}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }